import React, { useEffect } from 'react';
import InputField from '../../../../common/InputField';
import SelectOption from '../../../../common/SelectOption';
import { useDispatch, useSelector } from 'react-redux';
import DailyPricingOptions from './DailyPricingOption/DailyPricingOption';
import WeeklyPricingOption from './WeeklyPricingOption/WeeklyPricingOption';
import MonthlyPricingOption from './MonthlyPricingOption/MonthlyPricingOption';
import DedicatedDesk from '../DedicatedDesk/DedicatedDesk';
import { useState } from 'react';
import { Form, Input, Button, Checkbox, Row, Col } from 'antd';
import Amenities from '../Amenities/Amenities';
import Addons from '../Addons/Addons';
import KeepInMind from '../KeepInMind/KeepInMind';
import FieldName from '../../../../common/FieldName';
import {numberOfSeatValidation} from "../../../../../helper/FeildValidations";
import Packages from "../Packages/Packages";
import {SPACE_CATEGORY, SPACE_PAYMENT_OPTIONS} from "../../../../common/constants";
import Discount from "../../../../common/Discounts";
import {getPricingOptionsDayArray} from '../../SpaceAction';

const HotDesk = ({ index, form, activityId, name, currency, isEdit }) => {
  const formFields = isEdit ? form.getFieldValue() : null;
  const cancellationPolicies = useSelector(
    (state) => state.space?.cancellationPolicies?.data || []
  );
  const dispatch = useDispatch();
  const [count, setCount] = useState([1])
  const [selectedPricingOptions, setPricingOptions] = useState(isEdit ? formFields.events[index].chargings?.map(c => c.chargingType.id) : []);
  const paymentOptions = useSelector((state) => state.space?.paymentOptions?.data.filter(i => i.name === 'Daily' || i.name === 'Weekly' || i.name === 'Monthly') || []);//
  let weeklyPricingOptionData = {};
  let dailyPricingOptionData = {};
  let monthlyPricingOptionData = {};
  if(isEdit && formFields?.events){
    weeklyPricingOptionData = formFields.events[index]?.chargings?.find(c => c.chargingTypeDesc.name === 'Weekly') || {}
    dailyPricingOptionData = formFields.events[index]?.chargings?.find(c => c.chargingTypeDesc.name === 'Daily') || {}
    monthlyPricingOptionData = formFields.events[index]?.chargings?.find(c => c.chargingTypeDesc.name === 'Monthly') || {}
  }
  useEffect(() => {
    if(!isEdit){
      form.setFieldsValue({
        events: [
          {
            eventType: {
              id: activityId,
              name: name,
            },
          },
        ],
      });
    }
  }, []);

  useEffect(()=>{
    dispatch(getPricingOptionsDayArray(selectedPricingOptions));
  },[selectedPricingOptions])

  const handleSelected = (option) => {
    setPricingOptions([...selectedPricingOptions, option]);
  };
  const deselectItems = (option) => {
    const changeValue = selectedPricingOptions.filter((i) => i !== option);
    setPricingOptions(changeValue);
  };
  const getPaymentOptionName = (id) => {
    const { name } = paymentOptions.find((i) => i.id === id);
    return name;
  };

  const handleAddPackages = () => {
    setCount([...count, (count[count.length - 1] + 1)]);
  };

  const handleRemovePackages = (selectedIndex) => {
    const copy = [...count];
    const stat = copy.filter((value, index) => { return index !== selectedIndex});

    setCount([...stat])
  };

  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!',
    },
  ];
  return (
    <div className="basic-details-wrapper">
      <Form.Item name={['events', index, 'eventType', 'id']}> </Form.Item>
      {/* <Form.Item name={['events', index, 'eventType', 'name']}></Form.Item> */}

      <InputField
        name={['events', index, 'seatArrangements', 0, 'max']}
        label={'Number Of Seats'}
        rules={numberOfSeatValidation}
      />

      <SelectOption
        isMultiple={false}
        name={['events', index, 'cancellationPolicy', 'id']}
        placeholder={'Cancellation Policies'}
        rules={rules}
        label={'Cancellation Policies'}
        values={cancellationPolicies}
        valueName={'id'}
        labelName={'name'}
        handleOnSelect={null}
      />
      <SelectOption
        isMultiple={true}
        // name={['events', index, 'pricingOption']}
        placeholder={'Charging Types'}
        rules={rules}
        label={'Charging Types'}
        values={paymentOptions}
        handleOnSelect={handleSelected}
        handleOnDeselect={deselectItems}
        labelName={'name'}
        valueName={'id'}
        value={selectedPricingOptions}
      />

      {selectedPricingOptions.map((option, index) => {
          if (getPaymentOptionName(option) === SPACE_PAYMENT_OPTIONS.DAILY) {
              return (
                  <Packages
                      form={form}
                      paymentOption={SPACE_PAYMENT_OPTIONS.DAILY}
                      packageCategory={SPACE_CATEGORY.WORK}
                      hotDeskIndex={0}
                      pricingOptionIndex={index}
                      currency={currency}
                      isEdit={isEdit}
                  />
              );
            } else if (getPaymentOptionName(option) === SPACE_PAYMENT_OPTIONS.WEEKLY) {
            return (
                <Packages
                    form={form}
                    paymentOption={SPACE_PAYMENT_OPTIONS.WEEKLY}
                    packageCategory={SPACE_CATEGORY.WORK}
                    hotDeskIndex={0}
                    pricingOptionIndex={index}
                    currency={currency}
                    isEdit={isEdit}
                />

            );
          } else if (getPaymentOptionName(option) === SPACE_PAYMENT_OPTIONS.MONTHLY){
            return (
                <Packages
                    form={form}
                    paymentOption={SPACE_PAYMENT_OPTIONS.MONTHLY}
                    packageCategory={SPACE_CATEGORY.WORK}
                    hotDeskIndex={0}
                    pricingOptionIndex={index}
                    currency={currency}
                    isEdit={isEdit}
                />

            );
          }
      })}

      {selectedPricingOptions?.length > 0 ? selectedPricingOptions.map((option, index) => {
        if (getPaymentOptionName(option) === 'Daily') {
          return (
            <DailyPricingOptions
              form={form}
              hotdeskIndex={0}
              pricingOptionIndex={index}
              currency={currency}
              paymentOptionId={option}
              values={isEdit? dailyPricingOptionData:null}
              isEdit={isEdit}
            />
          );
        } else if (getPaymentOptionName(option) === 'Weekly') {
          return (
            <WeeklyPricingOption
              form={form}
              hotdeskIndex={0}
              pricingOptionIndex={index}
              currency={currency}
              paymentOptionId={option}
              values={isEdit? weeklyPricingOptionData :null}
              isEdit={isEdit}
            />
          );
        }
        else if (getPaymentOptionName(option) === 'Monthly'){
          return (
            <MonthlyPricingOption
              form={form}
              hotdeskIndex={0}
              pricingOptionIndex={index}
              currency={currency}
              paymentOptionId={option}
              values={isEdit? monthlyPricingOptionData:null}
              isEdit={isEdit}
            />
          );
        }
      }) : null}
      <Amenities name={['events', 0, 'amenities']} form={form} selectedPricingOptions={selectedPricingOptions}/>
        {isEdit ? 
      ( <><Addons name={['events', 0, 'addOns']} formAddOns={formFields.events[index].spaceAddOns} isEdit={isEdit} />
        <KeepInMind name={['events', 0, 'keepInMind']} formKeepInMinds={formFields.events[index].keepInMind} isEdit={isEdit}  /></>)
      : (<div><Addons name={['events', 0, 'addOns']}/>
        <KeepInMind name={['events', 0, 'keepInMind']} /></div>)}
    </div>
  );
};

export default HotDesk;
